import Splide from '@splidejs/splide';

export default function () {
  const featureSlides = document.querySelectorAll('.splide--features');
  if (featureSlides.length > 0) {
    featureSlides.forEach(featureSlide => {
      new Splide(featureSlide as HTMLElement, {
        perMove: 1,
        perPage: 3,
        gap: '0.875em',
        pagination: false,
        loop: true,
        type: 'loop',
      }).mount();
    });
  }

  const testimonialsSlides = document.querySelectorAll('.splide--testimonials');
  if (testimonialsSlides.length > 0) {
    testimonialsSlides.forEach(testimonialsSlide => {
      new Splide(testimonialsSlide as HTMLElement, {
        perMove: 1,
        perPage: 1,
        gap: '0.875em',
        loop: false,
        type: 'slide',
        arrows: true,
        pagination: true,
      }).mount();
    });
  }
}